import React, { useEffect, useState } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";

const AgoraVideoCall = () => {
  const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

  const [options, setOptions] = useState({
    appid: "",
    channel: "",
    token: "",
    uid: null,
  });

  const [localTracks, setLocalTracks] = useState({
    videoTrack: null,
    audioTrack: null,
  });

  const [remoteUsers, setRemoteUsers] = useState({});

  useEffect(() => {
    const urlParams = new URL(window.location.href).searchParams;
    const appid = urlParams.get("appid");
    const channel = urlParams.get("channel");
    const token = urlParams.get("token");

    if (appid && channel) {
      setOptions((prev) => ({ ...prev, appid, channel, token }));
      handleJoin();
    }
  }, []);

  const handleJoin = async () => {
    try {
      const [uid, audioTrack, videoTrack] = await Promise.all([
        client.join(options.appid, options.channel, options.token || null),
        AgoraRTC.createMicrophoneAudioTrack(),
        AgoraRTC.createCameraVideoTrack(),
      ]);

      setOptions((prev) => ({ ...prev, uid }));
      setLocalTracks({ audioTrack, videoTrack });

      videoTrack.play("local-player");
      client.on("user-published", handleUserPublished);
      client.on("user-unpublished", handleUserUnpublished);

      await client.publish([audioTrack, videoTrack]);
      // console.log("Publish success");
    } catch (error) {
      // console.error("Error joining channel: ", error);
    }
  };

  const handleLeave = async () => {
    try {
      localTracks.videoTrack?.stop();
      localTracks.audioTrack?.stop();
      localTracks.videoTrack?.close();
      localTracks.audioTrack?.close();

      setLocalTracks({ videoTrack: null, audioTrack: null });

      Object.keys(remoteUsers).forEach((uid) => {
        const player = document.getElementById(`player-wrapper-${uid}`);
        if (player) player.remove();
      });

      setRemoteUsers({});
      await client.leave();
      // console.log("Client leaves channel successfully");
    } catch (error) {
      // console.error("Error leaving channel: ", error);
    }
  };

  const handleUserPublished = async (user, mediaType) => {
    try {
      await client.subscribe(user, mediaType);
      // console.log("Subscribe success");

      setRemoteUsers((prev) => ({ ...prev, [user.uid]: user }));

      if (mediaType === "video") {
        const player = document.createElement("div");
        player.id = `player-wrapper-${user.uid}`;
        player.innerHTML = `
          <p class="player-name">RemoteUser(${user.uid})</p>
          <div id="player-${user.uid}" class="player"></div>
        `;
        document.getElementById("remote-playerlist").appendChild(player);

        user.videoTrack.play(`player-${user.uid}`);
      }

      if (mediaType === "audio") {
        user.audioTrack.play();
      }
    } catch (error) {
      // console.error("Error subscribing to user: ", error);
    }
  };

  const handleUserUnpublished = (user) => {
    const uid = user.uid;
    setRemoteUsers((prev) => {
      const updatedUsers = { ...prev };
      delete updatedUsers[uid];
      return updatedUsers;
    });

    const player = document.getElementById(`player-wrapper-${uid}`);
    if (player) player.remove();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleJoin();
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          id="appid"
          placeholder="App ID"
          value={options.appid}
          onChange={(e) => setOptions({ ...options, appid: e.target.value })}
        />
        <input
          type="text"
          id="channel"
          placeholder="Channel Name"
          value={options.channel}
          onChange={(e) => setOptions({ ...options, channel: e.target.value })}
        />
        <input
          type="text"
          id="token"
          placeholder="Token"
          value={options.token}
          onChange={(e) => setOptions({ ...options, token: e.target.value })}
        />
        <button type="submit" id="join">
          Join
        </button>
        <button type="button" id="leave" onClick={handleLeave}>
          Leave
        </button>
      </form>

      <div
        id="local-player"
        style={{ width: "400px", height: "300px", backgroundColor: "black" }}
      >
        <p id="local-player-name">Local Video</p>
      </div>

      <div id="remote-playerlist"></div>
    </div>
  );
};

export default AgoraVideoCall;
